import { SerializedTreeNode } from 'modules/job_catalog/pages/JobCatalogTreePage/types'

import { ParsedEntity, RoleLevel } from './types'

export const extractRoleLevelsFromTree = (
  tree: SerializedTreeNode | null | undefined
): RoleLevel[] => {
  if (!tree) return []

  const roleLevels: RoleLevel[] = []

  const traverseTree = (
    node: SerializedTreeNode,
    familyName?: string,
    functionName?: string,
    roleName?: string
  ) => {
    if (!node?.type || !node.name || !node.node_uuid) return

    const context = {
      family: node.type === 'jobcatalog_treefamily' ? node.name : familyName,
      function: node.type === 'jobcatalog_treefunction' ? node.name : functionName,
      role: node.type === 'jobcatalog_treerole' ? node.name : roleName,
    }

    if (node.type === 'jobcatalog_treelevel' && context.role) {
      roleLevels.push({
        uuid: node.node_uuid,
        name: node.name,
        roleName: context.role,
        familyName: context.family,
        functionName: context.function,
      })
    }

    node.children?.forEach((child) => {
      traverseTree(child, context.family, context.function, context.role)
    })
  }

  traverseTree(tree)
  return roleLevels
}

export const parseRoleLevelsFromExtracted = (roleLevels: RoleLevel[]): ParsedEntity[] => {
  if (roleLevels.length === 0) return []

  const groupedByRole = new Map<
    string,
    Array<{
      subId: string
      subName: string
      subSearchKeys: string[]
    }>
  >()

  for (const level of roleLevels) {
    const roleKey = level.functionName
      ? `${level.functionName} / ${level.roleName}`
      : level.roleName
    const existing = groupedByRole.get(roleKey) || []
    const searchKeys = [level.name, level.roleName]

    if (level.familyName) {
      searchKeys.push(level.familyName)
      if (level.functionName) {
        searchKeys.push(level.functionName, `${level.familyName} ${level.functionName}`)
        searchKeys.push(`${level.familyName} ${level.functionName} ${level.roleName}`)
      }
    }

    existing.push({
      subId: level.uuid,
      subName: level.name,
      subSearchKeys: searchKeys,
    })
    groupedByRole.set(roleKey, existing)
  }

  return Array.from(groupedByRole.entries()).map(([roleKey, levels], index) => ({
    expanded: true,
    id: `${roleKey.toLowerCase().replace(/\s+/g, '_')}_${index}`,
    name: roleKey,
    subItems: levels,
  }))
}
